import styled from 'styled-components';
import { IProduct } from '../../../../interfaces/Product.interfaces';
import { ProductHorizontalListSummaryView } from '../../../../views/Product/listView/ProductHorizontalListSummaryView/ProductHorizontalListSummaryView';

interface RecommendedProductsSectionProps {
  products: IProduct[];
}

export const RecommendedProductsSection = ({ products }: RecommendedProductsSectionProps) => {
  const convertProductsToDoubleArray = (products: IProduct[]): IProduct[][] => {
    const chunkedProducts = [];
    for (let i = 0; i < products.length; i += 2) {
      chunkedProducts.push(products.slice(i, i + 2));
    }
    return chunkedProducts;
  };
  return (
    <Container>
      <Title>{'강력 추천하는 매물'}</Title>
      <ProductsBox>
        {convertProductsToDoubleArray(products).map((group) => (
          <ItemsContainer key={`items-${group[0].id}`}>
            {group.map((product) => (
              <ItemWrapper key={product.id}>
                <ProductHorizontalListSummaryView product={product} listType="home-recommended" />
              </ItemWrapper>
            ))}
            {group.length === 1 && <ItemWrapper />}
          </ItemsContainer>
        ))}
      </ProductsBox>
    </Container>
  );
};

const Container = styled.div`
  display: flex;

  padding: 0px 16px 32px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: var(--radius-large, 16px);
  align-self: stretch;
`;

const Title = styled.h3`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* Display/XX-Large/xxl-bold */
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 26px */
`;

const ProductsBox = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;
`;

const ItemsContainer = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
`;

const ItemWrapper = styled.div`
  flex: 1;
`;
